import { render, staticRenderFns } from "./BlurEffect.vue?vue&type=template&id=85a00458&"
import script from "./BlurEffect.vue?vue&type=script&lang=js&"
export * from "./BlurEffect.vue?vue&type=script&lang=js&"
import style0 from "./BlurEffect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports